module.exports = __webpack_public_path__ + "static/media/HeaderLogo.d874d06e.svg";